<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-modal title="Mes objets" size="lg" hide-footer centered v-model="modalSwitch" id="my-modal">
    <div v-if="objects">
      <b-container class="container-object">
        <b-row class="row-objects">
          <b-col>
            <a
              style="color: #cd8c31;"
              href="https://cdn.exploreve.fr/content/sac_a_dos/codex_IM2-1.pdf"
              target="_blank"
            >
              <b-icon-check-box />
              {{ " Codex" }}
            </a>
          </b-col>
        </b-row>
        <b-row class="row-objects" v-for="object in objects" :key="object.name">
          <b-col v-if="!object.hidden">
            <b-icon-check-box v-if="object.recover" />
            <b-icon-square v-else />
            {{ object.label }}
            <img height="40px" :src="'https://cdn.exploreve.fr' + object.icon" alt />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>
<style>
.container-object {
  padding: 30px;
  display: block;
}
.row-objects {
  border-top: 2px solid black;
  height: 40px;
  align-content: center;
}
</style>
<script>
export default {
  props: {
    currentModal: Object,
    open: Boolean,
    objects: Array
  },
  data: function () {
    return {
      modalSwitch: false
    };
  },
  watch: {
    open: function () {
      this.modalSwitch = true;
    }
  }
};
</script>
